import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'

import { getCurrentMenuId } from '../selectors/appState'
import { menusAndItemsRequested } from '../actions/menus'
import ConcessionsCartSidebar from '../containers/ConcessionsCartSidebar'
import Items from '../containers/Items'
import Navbar from '../containers/Navbar'
import CategoryBar from '../containers/CategoryBar'

import styles from './Main.module.scss'

const Main = ({
  className,
  fetchMenusAndItems,
}) => {

  const classNames = cn(styles.main, className)

  useEffect(() => {
    if (localStorage.getItem('accessToken')) {
      fetchMenusAndItems()
    }
  }, [fetchMenusAndItems])

  return (
    <div className={classNames}>
      <Navbar className={styles.navbar} />
      <ConcessionsCartSidebar className={styles.sidebar} />
      <div className={styles.content}>
        <CategoryBar />
        <Items />
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const currentMenuUuid = getCurrentMenuId(state)
  return {
    currentMenuUuid,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenusAndItems: () => {
      dispatch(menusAndItemsRequested())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Main)
